module.exports = __webpack_public_path__ + "img/logo NCDs.9abf7b5d.png";